
export class ListarPacientesEntrada {

    nomeCpf: string = '';
    lotacoesFechadas: boolean = false;

    constructor(init?: Partial<ListarPacientesEntrada>) {
        Object.assign(this, init);
    }
}